const isRemote = tile => !tile.isLocal;
const isLocalShare = tile => tile.isLocal && tile.isScreenShare;
const isLocalCamera = tile => tile.isLocal && !tile.isScreenShare;

function bestRemote(tiles) {
  return tiles.find(tile => isRemote(tile) && tile.isScreenShare) || tiles.find(isRemote) || null;
}

function fallbackPeerId(tiles) {
  const localShare = tiles.find(tile => isLocalShare(tile) && tile.stream);
  if (localShare) {
    return localShare.id;
  }

  return bestRemote(tiles)?.id ?? tiles.find(isLocalCamera)?.id ?? null;
}

function presentationOnStage(tiles) {
  return tiles.find(tile => isRemote(tile) && tile.isScreenShare) || tiles.find(isLocalShare) || null;
}

export function pickPrimaryPeerId({ currentPeerId, chosenByUser, tiles }) {
  const current = tiles.find(tile => tile.id === currentPeerId);
  if (!current) {
    return fallbackPeerId(tiles);
  }
  const presentation = presentationOnStage(tiles);
  if (!chosenByUser && presentation && presentation.id !== current.id && !(isRemote(current) && current.isScreenShare)) {
    return presentation.id;
  }
  if (!chosenByUser && isLocalCamera(current)) {
    return bestRemote(tiles)?.id ?? current.id;
  }

  return current.id;
}
